import React, { useContext, Fragment, useState, useEffect } from 'react';
import loadable from '@loadable/component';
import Modal from '../Modal';
import Animation from '../Animation';
import SlideInCard from '../SlideInCard';
import RoundButton from '../RoundButton';
import enquirySubmitted from '../../animations/enquirySubmitted.json';
import { Context } from '../../context/AppContext';
import { MODALS } from '../../constants';
import FullScreenLoader from '../FullScreenLoader';

const Form = loadable(() => import('./EnquiryForm'), {
  fallback: <FullScreenLoader />,
});

const EnquiryForm = ({ defaults = {} }) => {
  const modalName = MODALS.ENQUIRY_FORM;

  const {
    media: { mobile },
    modal: { showModal, modals },
    user: { userContactDetails },
  } = useContext(Context);

  const { data = defaults } = modals[modalName];
  const [slideInShow, setSlideInShow] = useState(false);
  const [businessName, setBusinessName] = useState(false);

  useEffect(() => {
    if (data.businessName || defaults.businessName) {
      setBusinessName(data.businessName || defaults.businessName);
    }
    return () => {};
  }, [data.businessName, defaults.businessName]);

  return (
    <Fragment>
      <Modal
        name={modalName}
        onClickOutside={() => showModal(MODALS.MODAL_CONFIRMATION)}
      >
        <Form
          data={{ ...defaults, ...data, ...userContactDetails }}
          slideInShow={slideInShow}
          setSlideInShow={setSlideInShow}
        />
      </Modal>
      <SlideInCard
        show={slideInShow}
        title="Success!"
        message={`Your enquiry is zooming through cyberspace over to ${businessName}.`}
        setShow={setSlideInShow}
        icon={
          <Animation
            animation={enquirySubmitted}
            loop={false}
            height={mobile ? 150 : 100}
            width={mobile ? 150 : 100}
          />
        }
      >
        <RoundButton
          onClick={() => setSlideInShow(false)}
          style={{ width: '110px' }}
          theme="outlineGrey"
        >
          Return
        </RoundButton>
      </SlideInCard>
    </Fragment>
  );
};

export default EnquiryForm;
